import { useCallback } from 'react';
import { useSafeLocalStorage } from 'src/hooks/use-storage';

const storageKey = 'USE_NEW_NWP_SEARCH';

export function useNewNwpSearch() {
  const safeLocalStorage = useSafeLocalStorage();
  const active = safeLocalStorage.getItem(storageKey) === 'true';

  const toggle = useCallback(() => {
    if (active) {
      safeLocalStorage.removeItem(storageKey);
    } else {
      safeLocalStorage.setItem(storageKey, 'true');
    }
    location.reload();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { active, toggle };
}
